export const visit = (vm, at) => {
vm(require("UIComponents/lang/en.lyaml"));
vm(require("feedback-shared-ui/lang/en.lyaml"));
at({ "en": { "testSurvey": "Test survey", "testHeader": "This is a test survey.", "testBody": "This submission won't be recorded.", "app": { "htmlTitle": "Feedback Web UI" }, "pages": { "error": { "close": "Close", "heading": "There was a problem loading the survey. Please try again later." }, "navigation": { "close": "close frame" } } } });
};